// extracted by mini-css-extract-plugin
module.exports = {"overflower":"Overflower__overflower__Eaq48","overflowerLong":"Overflower__overflowerLong__r9f9o","overflowerShort":"Overflower__overflowerShort__FCMOr"};